import { Component } from '@angular/core';
import { PaymentTypeService } from '../payment-type.service';
import { PaymentType } from '../payment-type';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-payment-type-edit',
  templateUrl: 'edit.component.html',
})
export class PaymentTypeEditComponent {
  /**
   * Details of the paymentType being edited.
   */
  public paymentType: PaymentType;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {PaymentTypeService} paymentTypeService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private paymentTypeService: PaymentTypeService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.paymentTypeService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadPaymentType(params.id));
  }

  /**
   * Perform the edit action which send the edited paymentType to the backend.
   */
  public edit() {
    const editPaymentType = this.paymentTypeService
      .updatePaymentType(this.paymentType.id, this.paymentType)
      .subscribe(
        (result: PaymentType) => {
          this.notificationService.success(
            `Payment Type Updated`,
            `The payment Type ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.paymentType = new PaymentType();
          editPaymentType.unsubscribe();
          this.router.navigate(['/payment-types']);
        },
        err => {
          this.notificationService.error(
            `Payment Type Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/payment-types']);
        },
      );
  }

  /**
   * Loads the requested paymentType so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadPaymentType(id: string) {
    this.paymentTypeService.findPaymentType(id).subscribe(
      result => {
        this.paymentType = result;
      },
      err => {
        this.notificationService.error(
          `Payment Type Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/payment-types']);
      },
    );
  }
}
